import { deepAnalysisApi } from '../service';
import { UrlCluster, FetchUrlClustersParams, AddUrlClusterParams, DeleteUrlClusterParams, UpdateUrlClusterParams } from './types';

export const urlClustersApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchUrlClusters: builder.query<UrlCluster[], FetchUrlClustersParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/url-cluster/${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'UrlClusters', id: args.w_guid }],
        }),

        addUrlCluster: builder.mutation<UrlCluster, AddUrlClusterParams>({
            query: (args) => {
                return {
                    method: 'POST',
                    body: args,
                    url: '/url-cluster',
                };
            },

            invalidatesTags: (result, error, args) => [{ type: 'UrlClusters', id: args.w_guid }],
        }),

        updateUrlCluster: builder.mutation<UrlCluster, UpdateUrlClusterParams>({
            query: (args) => {
                const { w_guid, cluster_guid, ...rest } = args;

                return {
                    method: 'PATCH',
                    body: rest,
                    url: `/url-cluster/${w_guid}/${cluster_guid}`,
                };
            },

            invalidatesTags: (result, error, args) => [{ type: 'UrlClusters', id: args.w_guid }],
        }),

        deleteUrlCluster: builder.mutation<void, DeleteUrlClusterParams>({
            query: (args) => {
                const { w_guid, cluster_guid } = args;

                return {
                    method: 'DELETE',
                    url: `/url-cluster/${w_guid}/${cluster_guid}`,
                };
            },

            invalidatesTags: (result, error, args) => [
                { type: 'UrlClusters', id: args.w_guid },
                { type: 'ServiceableUrls', id: args.w_guid },
                { type: 'ServiceableUrlsCount', id: args.w_guid },
                { type: 'FailedChecks', id: args.w_guid },
                { type: 'AffectedUrls', id: args.w_guid },
            ],
        }),
    }),
});

export const { useFetchUrlClustersQuery, useAddUrlClusterMutation, useUpdateUrlClusterMutation, useDeleteUrlClusterMutation } = urlClustersApi;
